export default "__VITE_ASSET__n94tfOZV__"